import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';
class DVCFileC203API extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFileC203s';
}
export default new DVCFileC203API();
